import { Expose } from "class-transformer";
import { CompanyAssessmentBase } from "domain/model/base";

export default class CompanyAssessment extends CompanyAssessmentBase {
  @Expose({name: "company_name"})
  companyName?: string;
};
